import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMediaObjectRatio1To132(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconMediaObjectRatio1To132"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M11 7H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2M7 5a4 4 0 0 0-4 4v14a4 4 0 0 0 4 4h4a4 4 0 0 0 4-4V9a4 4 0 0 0-4-4zm10.5 3a1 1 0 0 1 1-1H28a1 1 0 1 1 0 2h-9.5a1 1 0 0 1-1-1m1 7a1 1 0 1 0 0 2H28a1 1 0 1 0 0-2zm-1-3a1 1 0 0 1 1-1H23a1 1 0 1 1 0 2h-4.5a1 1 0 0 1-1-1m1 7a1 1 0 1 0 0 2H23a1 1 0 1 0 0-2z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconMediaObjectRatio1To132);
